module.exports = __webpack_public_path__ + "static/2012-layer-2-1eeaac3d4c4c71d23c948a8f5e10c851.png";